<template>
  <Transition
    name="slide-y-up-transition"
    :duration="duration"
    enter-active-class="slide-move"
    enter-from-class="slideYIn"
    leave-to-class="slideYOut"
    leave-active-class="slide-move"
  >
    <slot></slot>
  </Transition>
</template>

<script>
import { baseTransition } from "../mixin.js"

export default {
  name: "slide-y-up-transition",
  mixins: [baseTransition],
  props: {
    styles: {
      type: Object,
      default: () => {
        return {
          animationFillMode: "both",
          animationTimingFunction: "cubic-bezier(.25,.8,.50,1)",
        }
      },
    },
  },
}
</script>

<style lang="scss">
.slideYIn,
.slideYOut {
  opacity: 0;
  transform: translateY(-15px);
}

.slide-move {
  transition: transform 0.3s;
}
</style>
